import * as Common from '@piccolohealth/pbs-common';
import type { SelectOption } from '@piccolohealth/ui';
import React from 'react';
import { FormStack } from '../../../components/forms/FormStack';
import { HookedFormField } from '../../../components/forms/HookedFormField';
import { HookedInput } from '../../../components/forms/HookedInput';
import { HookedLabelChooser } from '../../../components/forms/HookedLabelChooser';
import { HookedSelect } from '../../../components/forms/HookedSelect';
import { HookedSingleDatepicker } from '../../../components/forms/HookedSingleDatepicker';
import { restrictivePracticeTypeOptions } from './RestrictivePracticeTypeTag';

export const ParticipantRestrictivePracticeForm = () => {
  const typeOptions: SelectOption<Common.RestrictivePracticeType>[] = Object.values(
    restrictivePracticeTypeOptions,
  );

  return (
    <FormStack>
      <HookedFormField name='type' label='Type' required>
        <HookedSelect name='type' size='sm' options={typeOptions} optionVariant='tag' />
      </HookedFormField>

      <HookedFormField
        name='description'
        label='Description'
        helperText='How would you describe the restrictive practice?'
      >
        <HookedInput name='description' placeholder='Enter a description..' />
      </HookedFormField>

      <HookedFormField
        name='identifiedAt'
        label='Date identified'
        helperText='When was the restrictive practice identified?'
      >
        <HookedSingleDatepicker name='identifiedAt' size='sm' />
      </HookedFormField>

      <HookedFormField
        name='startedAt'
        label='Date started'
        helperText='When did the restrictive practice start being used in practice?'
      >
        <HookedSingleDatepicker name='startedAt' size='sm' />
      </HookedFormField>

      <HookedFormField
        name='ceasedAt'
        label='Date ceased'
        helperText='When did the restrictive practice stop being used in practice?'
      >
        <HookedSingleDatepicker name='ceasedAt' size='sm' />
      </HookedFormField>

      <HookedFormField name='labelIds' label='Labels'>
        <HookedLabelChooser
          name='labelIds'
          type={Common.LabelType.ParticipantRestrictivePractice}
        />
      </HookedFormField>
    </FormStack>
  );
};
